import type { LucideIcon } from "lucide-react";
import ActivityIcon from "lucide-react/dist/esm/icons/activity";
import BarChart3Icon from "lucide-react/dist/esm/icons/bar-chart-3";
import BellIcon from "lucide-react/dist/esm/icons/bell";
import CalendarDaysIcon from "lucide-react/dist/esm/icons/calendar-days";
import ContactRoundIcon from "lucide-react/dist/esm/icons/contact-round";
import InboxIcon from "lucide-react/dist/esm/icons/inbox";
import SettingsIcon from "lucide-react/dist/esm/icons/settings";
import SparklesIcon from "lucide-react/dist/esm/icons/sparkles";
import UsersIcon from "lucide-react/dist/esm/icons/users";
import UsersRoundIcon from "lucide-react/dist/esm/icons/users-round";
import WorkflowIcon from "lucide-react/dist/esm/icons/workflow";

export type NavPath =
  | "/"
  | "/alerts"
  | "/inbox"
  | "/scenarios"
  | "/segments"
  | "/analytics"
  | "/calendar"
  | "/contacts"
  | "/personas"
  | "/aio"
  | "/settings";

export interface NavItem {
  to: NavPath;
  label: string;
  icon: LucideIcon;
  /** 画面の性格。分析系とオペレーション系を混在させないためグループで明示する（原則 11）。 */
  description: string;
  exact?: boolean;
}

export interface NavGroup {
  id: string;
  label: string;
  items: NavItem[];
}

export const NAV_GROUPS: NavGroup[] = [
  {
    id: "operations",
    label: "監視",
    items: [
      {
        to: "/",
        label: "概況",
        icon: ActivityIcon,
        description: "全体状態と要対応キュー",
        exact: true
      },
      { to: "/alerts", label: "アラート", icon: BellIcon, description: "深刻度別の対応キュー" },
      { to: "/inbox", label: "インボックス", icon: InboxIcon, description: "未返信のAI監視と返信" }
    ]
  },
  {
    id: "automation",
    label: "自動化",
    items: [
      {
        to: "/scenarios",
        label: "シナリオ",
        icon: WorkflowIcon,
        description: "トリガー×条件×アクション"
      }
    ]
  },
  {
    id: "audience",
    label: "オーディエンス",
    items: [
      {
        to: "/contacts",
        label: "顧客",
        icon: UsersIcon,
        description: "顧客マスタの検索と絞り込み"
      },
      {
        to: "/segments",
        label: "セグメント",
        icon: UsersRoundIcon,
        description: "RFMベースの動的な配信対象"
      },
      {
        to: "/personas",
        label: "ペルソナ",
        icon: ContactRoundIcon,
        description: "AIが生成した代表顧客像"
      }
    ]
  },
  {
    id: "analytics",
    label: "分析",
    items: [
      {
        to: "/analytics",
        label: "レポート",
        icon: BarChart3Icon,
        description: "KPI・トレンド・内訳"
      },
      { to: "/aio", label: "AIO", icon: SparklesIcon, description: "AI検索最適化の整備と観測" },
      {
        to: "/calendar",
        label: "カレンダー",
        icon: CalendarDaysIcon,
        description: "運用イベントのマイルストーン記録"
      }
    ]
  },
  {
    id: "system",
    label: "システム",
    items: [
      {
        to: "/settings",
        label: "設定",
        icon: SettingsIcon,
        description: "接続・センダー・MCP"
      }
    ]
  }
];

export const NAV_ITEMS: NavItem[] = NAV_GROUPS.flatMap((group) => group.items);
